import rAxios from "utils/rAxios";
import { ILog } from "./log.model";

export const onLogGetForAll = (): Promise<ILog[]> =>
	rAxios.get(`/admin/useractivity`);

export const onLogGetForSymbolNumber = (symbolNumber: string): Promise<ILog> =>
	rAxios.get(`/admin/useractivity/${symbolNumber}`);
